import { Component, OnDestroy, computed, input, signal } from '@angular/core'
import { Observable, Subject, takeUntil } from 'rxjs'
import { BwcMetrics, getMetricFromMap } from '../../enums/bwc-metrics.enum'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { MetricModel } from 'src/app/shared/models/metric.model'
import { Layers } from 'src/app/shared/layers-config/layers'
import { ProviderInfo } from 'src/app/obstacle/model/provider-info.model'

@Component({
  selector: 'app-bwc-legend',
  templateUrl: './bwc-legend.component.html',
  standalone: false,
})
export class BwcLegendComponent implements OnDestroy {
  private cleanUp$ = new Subject<void>()
  public metrics: string | undefined
  public isRoadMetricLayerVisible = signal(false)
  public isWeatherPredictionLayerVisible = signal(false)
  public isProvider4FogLayerVisible = signal(false)
  public isProvider4HeavyRainLayerVisible = signal(false)
  public isProvider4SlipperyLayerVisible = signal(false)
  public isLayerSelectionVisible = false

  public roadMetric = signal<MetricModel | undefined>(undefined)
  public weatherPreditionMetric = signal<MetricModel | undefined>(undefined)
  public vehicleDataMetric = signal<MetricModel | undefined>(undefined)
  public providerInfo$ = input.required<Observable<ProviderInfo>>()

  public isOneVehicleDataLayerVisible = computed(
    () =>
      this.isProvider4HeavyRainLayerVisible() ||
      this.isProvider4FogLayerVisible() ||
      this.isProvider4SlipperyLayerVisible(),
  )

  public hasAnyLegendVisible = computed(
    () =>
      this.isRoadMetricLayerVisible() ||
      this.isWeatherPredictionLayerVisible() ||
      this.isOneVehicleDataLayerVisible(),
  )

  constructor(private appState: AppStateService) {
    this.evaluateQueryParameters()

    this.appState.stateChanged.pipe(takeUntil(this.cleanUp$)).subscribe(() => {
      console.log(
        'BwcLegendComponent: stateChanged event received, re-evaluating query parameters...',
      )
      this.evaluateQueryParameters()
    })
  }
  ngOnDestroy(): void {
    this.cleanUp$.next()
    this.cleanUp$.complete()
  }

  evaluateQueryParameters() {
    const layers = this.appState.getState().layers

    this.isWeatherPredictionLayerVisible.set(!!layers?.includes(Layers.WeatherPrediction.name))
    this.isRoadMetricLayerVisible.set(!!layers?.includes(Layers.RoadSegment.name))
    this.isProvider4FogLayerVisible.set(!!layers?.includes(Layers.Provider4Fog.name))
    this.isProvider4HeavyRainLayerVisible.set(!!layers?.includes(Layers.Provider4HeavyRain.name))
    this.isProvider4SlipperyLayerVisible.set(!!layers?.includes(Layers.Provider4Slippery.name))

    const roadMetricKeys = this.appState.selectMetrics(Layers.RoadSegment.name)
    if (roadMetricKeys && roadMetricKeys.length > 0) {
      this.roadMetric.set(getMetricFromMap(roadMetricKeys[0]))
    } else {
      this.roadMetric.set(undefined)
    }

    const weatherPredictionKeys = this.appState.selectMetrics(Layers.WeatherPrediction.name)
    if (weatherPredictionKeys && weatherPredictionKeys.length > 0) {
      this.weatherPreditionMetric.set(getMetricFromMap(weatherPredictionKeys[0]))
    } else {
      this.weatherPreditionMetric.set(undefined)
    }

    this.vehicleDataMetric.set(getMetricFromMap(BwcMetrics.VehicleData_Fog))
  }
}
